var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('transition',{attrs:{"name":"title-fade","appear":""}},[_c('div',{staticClass:"title mt-auto"},[_c('h1',{staticClass:"mt0 mb1"},[_vm._v("ANDREW GARDHOUSE")]),_c('p',{staticClass:"my2"},[_vm._v("Web Developer")])])]),_c('transition',{attrs:{"name":"options-fade","appear":""}},[_c('Options')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }